import { isChinaUser } from 'utils/ChinaUtil';

export default {
    isChinaUser: function() {
        return isChinaUser();
    },

    isOutOfChina: function(lat, lng) {
        if (lng < 72.004 || lng > 137.8347) {
            return true;
        } else if (lat < 0.8293 || lat > 55.8271) {
            return true;
        } else {
            return false;
        }
    }
};
